// Base reconnect delay (will increase exponentially on repeated failures)
export const INITIAL_RECONNECT_DELAY_MS = 1000; // 1 second initial delay
export const MAX_RECONNECT_DELAY_MS = 30000; // 30 seconds max delay
export const RECONNECT_BACKOFF_MULTIPLIER = 2;

// Legacy constant (kept for backward compatibility)
export const RECONNECT_DELAY_IN_MS = INITIAL_RECONNECT_DELAY_MS;

/**
 * Calculate reconnect delay with exponential backoff
 * @param attempt - The current reconnect attempt number (0-indexed)
 * @returns Delay in milliseconds
 */
export const getReconnectDelay = (attempt: number): number => {
  const delay = INITIAL_RECONNECT_DELAY_MS * Math.pow(RECONNECT_BACKOFF_MULTIPLIER, attempt);
  return Math.min(delay, MAX_RECONNECT_DELAY_MS);
};

export const TOKEN_PADDING_MINUTES = 5;

export const SpecialAgentWSType = {
  ERROR: 'ERROR',
  TASK_CREATED: 'TASK_CREATED',
  INPUT_REQUIRED: 'INPUT_REQUIRED',
  PROGRESS: 'PROGRESS',
  FINAL_RESULT: 'FINAL_RESULT'
};
